/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-15 17:38:33
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-03-16 16:24:15
 * @FilePath: \baishu_react_ui\src\Login\BsyRadioGroup\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import { BsyWebSocket } from "../../utils/BsyWebSocket";
import { BsyUtils } from "../../utils/Utils";
import { BsyWidget } from "../BsyWidget";
import "./index.css";
import { BsyConfig } from "../../global/BsyConfig";
import { doGraffiti } from "../../utils/doGraffiti";

class BsyFileUpload extends BsyWidget {
  static defaultProps = {
    baseCls: "bsy-upload",
    type: "upload",
    files: [],
    fileType: [],
    uploadURL: "/upload",
    uploadTokenURL: "/file/upload_token",
    uploadToMedia: !1,
    imageData: [],
    imageDataType: "",
    imageType: "json", // json 七牛返回的格式, base64 描述，不需要上传到七牛的地方使用
    allowBlank: !0,
    onFileSizeLimit: null,
    onValidateSuccess: null,
    onValidateFail: null,
    onAfterValidate: null,
    onUpload: null,
    onUploadSuccess: null,
    onUploadFail: null,
    onAfterUpload: null,
    download: !1, //打包下载
    iconCls: "icon-widget-upload",
    maxFileSize: 5242880,
    maxFileCount: 1,
    uploadToForm: !0,
    style: "white",
    size: "normal",
    mode: "upload",
    thumbWidth: 65,
    thumbHeight: 65,
    hasUploadBtn: !0,
    hasProgress: !0,
    hasPreview: !0,
    formMode: !1,
    grid2: !1,
    hasPreviewList: !0,
    onBeforeUpload: null,
    onFileThumbCreate: null,
    onFileRemove: null,
    onStopEdit: null,
  };

  constructor(props) {
    super({
      ...props,
      tipText: React.language("file"),
      uploadSite: window.FX.CONST.QN_BUCKET.UPLOAD_SITE || "qn",
    });

    this.element = React.createRef();
    this.$uploadInput = React.createRef();
    this.g_files = []; //记录所有已经上传的文件信息
    this.previewlist = [];
    this.tokenKey = this.options.uploadToMedia
      ? "imageUploadToken"
      : "fileUploadToken";
    this.tokenExpireKey = this.tokenKey + "Expires";
    this.getUploadURL();
    this.filterFiles();
    this.inputKey = 0;
  }

  getValue = () => {
    return [...this.g_files];
  };

  setValue = (files, s) => {
    const {
      dataId,
      formId,
      appId,
      authGroupId,
      rowIdx,
      subform,
      widgetName,
      designDataId,
      subformData,
    } = this.options;
    if (!BsyUtils.isArray(files)) {
      this.g_files = [];
    } else {
      this.g_files = [...files];
    }
    if (s) {
      var a = this.options;
      this.setState({ value: this.g_files });
      let data = {
        appId: appId,
        authGroupId: authGroupId,
        checkRepeat: [],
        dataId: dataId || designDataId || "",
        designDataId: null,
        entryId: formId,
        formId: formId,
        hasResult: true,
        popupFormPath: this.popupFormPath,
        values: {},
      };
      if (subform) {
        let id = subformData?.[rowIdx]?.id;
        if (id) {
          data["values"][widgetName] = {
            file: files[0] ? files[0] : {},
            subform: subform, //如果是子表单 传子表单的id
            id: id, //子表单数据id
          };
        }
      } else {
        data["values"][widgetName] = {
          file: files[0] ? files[0] : {},
        };
      }
      if (dataId) {
        // 有数据id的时候才执行更新逻辑
        React.axios("/data/online_edit_update", data).then((res) => {
          console.log(res);
        });
      }
      BsyUtils.applyFunc(this, a.onStopEdit, [this.g_files, null, this], !1);
    } else {
      this.setState({});
    }
  };

  componentDidMount() {
    super.componentDidMount();

    BsyWebSocket();
  }

  _trimFileName = (a) => {
    if (BsyUtils.isEmpty(a)) return "";
    var b = 20,
      c = a ? a.split(".").pop() : "";
    if (a.length - c.length - 1 > b) {
      a = a.slice(0, b - 1);
      a = a + "..." + c;
    }

    //  a.length - c.length - 1 > b && (a = a.slice(0, b - 1),
    //     a = a + "..." + c)
    return a;
  };
  filterFiles = () => {
    var b = this.options;
    var tmpvalue = [];
    if (b.value) {
      for (var i = 0; i < b.value.length; i++) {
        if (!b.value[i].error) {
          tmpvalue.push(b.value[i]);
        }
      }
    }

    b.value = tmpvalue;

    this.g_files = [...tmpvalue];
  };

  getUploadURL = () => {
    var b = this.options;
    // b.uploadSite = 'ctyun';
    switch (b.uploadSite) {
      case "qn":
        b.uploadURL = "https://upload.qiniup.com/";
        break;
      case "aliyun":
      case "minio":
      case "qcloud":
      case "huawei":
      case "localftp":
      case "ctyun": {
        //天翼云
        // FX.CONST.QN_BUCKET.PRIVATE_FILE = 'bobotest1'
        b.uploadURL = "/file/upload_file";
        break;
      }
      case "formAttributes": {
        // 描述信息 表单主题 报表背景 打印模板图片
        // FX.CONST.QN_BUCKET.PRIVATE_FILE = 'bobotest1'
        b.uploadURL = "/file/upload_des_img";
        break;
      }
      default: {
      }
    }
    return b.uploadURL;
  };

  _isTokenValid = () => {
    return (
      window.FX.STATIC[this.tokenKey] &&
      Date.now() < window.FX.STATIC[this.tokenExpireKey]
    );
  };
  _checkUploadToken = (a) => {
    var b = this,
      c = this.options;

    switch (c.uploadSite) {
      case "local":
      case "ctyun":
      case "aliyun":
      case "minio":
      case "qcloud":
      case "huawei":
      case "localftp":
      case "formAttributes": {
        a();
        break;
      }
      default: {
        this._isTokenValid()
          ? a()
          : window.FX.Utils.dataAjax(
            {
              url: c.uploadTokenURL,
              data: {
                site: c.uploadSite,
                isMedia: c.uploadToMedia,
              },
            },
            function (c) {
              window.FX.STATIC[b.tokenKey] = c.token;
              window.FX.STATIC[b.tokenExpireKey] = 18e5 + Date.now();
              a();
            },
            function (a) {
              BsyUtils.Vip.showUpgradeTip(a.responseJSON);
            }
          );
        break;
      }
    }
  };

  _checkUploadFiles = (a) => {
    var b = this,
      c = this.options;
    if (this.g_files.length + a.length > c.maxFileCount)
      return (
        tipAlert({
          msg: c.maxFileTip, //"最多允许选择 " + c.maxFileCount + " 个" + c.tipText,
          type: "warning",
        }),
        !1
      );
    var d = !0;
    if (a)
      for (
        var e = 0, f = a.length;
        e < f && ((d = d && b.checkFile(a[e])), d);
        e++
      );
    return d;
  };

  doUpload = () => {
    var a = this;
    if (!this.$uploadInput.current.files.length > 1) return;
    this._checkUploadToken(function () {
      a._doDataUpload();
    });
  };

  // _setProgress = (a, b) => {
  //     var c = this.options;
  //     if (c.hasProgress) {
  //         var d = parseInt(a / b * 100);
  //         d < 100 ? this.progress.setMessage(i18next.t("widget.file.uploading")) : this.progress.setMessage(i18next.t("widget.file.uploaded")),
  //             this.progress.setProgress(d)
  //     }
  // }
  onUpload = (a, b) => {
    // FX.FileUpload.superclass.onUpload.apply(this, arguments),
    BsyUtils.applyFunc(
      this,
      this.options.onUpload,
      [
        {
          files: null,
          up: a,
          total: b,
        },
      ],
      !1
    );
    this._setProgress(a, b);
  };

  _doDataUpload = () => {
    var a = this;
    var o = this.options;
    if (!BsyUtils.isFormDataSupported())
      return void tipAlert({
        type: "warning",
        msg: React.language("upload.browserNotSupportTip"),
      });

    var success = 0;
    var fail = 0;
    var c = {};

    var g = function (result, isoK, file, index) {
      if (success + fail === a.upFiles.length) {
        a.inputKey++;
        a.uploading = false;
        if (fail > 0) {
          a.onFail({
            failCount: fail,
            result: result,
          });
        } else {
          a.g_files = [...a.g_files, ...a.previewlist];

          a.setState({}, () => {
            a.onSuccess();
          });
        }
      }
    };

    if (this.upFiles) {
      this.uploading = true;
      this.previewlist = new Array(this.upFiles.length);
      this.previewlist.fill({});

      this.setState({}, () => {
        BsyUtils.forEach(a.upFiles, function (h, j) {
          a._doXhrUpload(
            j,
            function (d, e) {
              c[h] = d;
              // a.onUpload(f(), b)
            },
            function (e) {
              c[h] = j.size;
              // a.onUpload(f(), b);
              var file = { ...e.file };
              var isok = true;
              if (!file.hasOwnProperty("error")) {
                // file.index = ggd;
                // a.files.push(file);
                a.previewlist[h] = file;
                isok = true;
              } else {
                if (file.error > 7100) {
                  BsyUtils.Vip.showUpgradeTip(file);
                } else {
                  tipAlert({
                    type: "warning",
                    msg: React.language("error.qiniu.violation", {
                      file: file.name,
                    }),
                  });
                }
                isok = false;
              }
              success++;
              g(e, isok, file, h);
            },
            function (d) {
              c[h] = 0;
              // a.onUpload(f(), b);
              fail++;
              g(d, false, null, h);

              return !1;
            }
          );
          // }
        });
      });
    }
  };

  _doXhrUpload = (a, b, c, d) => {
    var j = this;
    var e,
      f = this.options,
      g = a.name,
      h = new FormData(),
      i = window.FX.STATIC.user ? window.FX.STATIC.user._id : "";
    if ("qn" === f.uploadSite) {
      h.append("file", a, a.name);
      h.append("token", window.FX.STATIC[this.tokenKey]);
      h.append(
        "x:bucketType",
        f.uploadToMedia
          ? BsyConfig().CONST.QN_BUCKET.PUBLIC_IMAGE
          : BsyConfig().CONST.QN_BUCKET.PRIVATE_FILE
      );
      h.append("x:uploader", i);
      if (f.uploadToForm) {
        h.append("x:appId", f.appId || window.FX.STATIC.APPID);
        h.append("x:entryId", f.entryId || window.FX.STATIC.ENTRYID);
        h.append(
          "x:field",
          f.imageDataType === "backgroundconfigurator"
            ? f.imageData
            : f.widgetName
        );
      }
    } else {
      h.append("file", a, a.name);
      h.append("token", window.FX.STATIC[this.tokenKey]);
      h.append(
        "x:bucketType",
        f.uploadToMedia
          ? BsyConfig().CONST.QN_BUCKET.PUBLIC_IMAGE
          : BsyConfig().CONST.QN_BUCKET.PRIVATE_FILE
      );
      h.append("x:uploader", i);
      if (f.uploadToForm) {
        h.append("x:appId", f.appId || window.FX.STATIC.APPID);
        h.append("x:entryId", f.entryId || window.FX.STATIC.ENTRYID);
        h.append("x:field", f.widgetName);
      }
    }

    window.FX.Utils.ajaxUpload(
      {
        url: f.uploadURL,
        data: h,
        onUpload: b,
      },
      function (a, b) {
        if (a.file) {
          "qn" === f.uploadSite
            ? c(a)
            : "oss" === f.uploadSite
              ? c(a)
              : c && c.apply(this, arguments);
        } else if (a.code) {
          BsyUtils.Vip.showUpgradeTip(a);
          BsyUtils.applyFunc(j, f.onUploadFail, [], !1);
        } else {
          d();
        }
        // return a.file ? void ("qn" === f.uploadSite ? c(a) : "oss" === f.uploadSite ? c(a) : c && c.apply(this, arguments)) : d()
      },
      d
    );
  };
  isUploaded = () => {
    return !BsyUtils.isObjectEmpty(this.g_files);
  };
  checkValidate = () => {
    var a = this.options,
      b = !0;
    this.setInvalidateTypeText("");
    a.allowBlank || (b = this.isUploaded());
    if (!b) {
      this.setInvalidateTypeText(React.language("item.required"));
    }
    b
      ? BsyUtils.applyFunc(this, a.onValidateSuccess, [], !1)
      : BsyUtils.applyFunc(this, a.onValidateFail, [], !1);
    BsyUtils.applyFunc(this, a.onAfterValidate, [], !1);
    return b;
  };
  checkFile = (a) => {
    var b = this.options;
    if (!a) return !1;
    var c = a.name,
      d = c.split(".").pop(),
      e = !0;

    if (
      e &&
      b.fileType.length > 0 &&
      b.fileType.indexOf(d.toLowerCase()) === -1
    ) {
      tipAlert({
        msg: React.language("upload.notSupportFileTip"),
        type: "warning",
      });
      e = !1;
      return e;
    }

    if (a.size == 0) {
      e = !1;
      tipAlert({
        msg: React.language("upload.maxLimitTip0"),
        type: "warning",
      });
      return e;
    }

    var f = b.maxFileSize;
    var g = BsyUtils.applyFunc(this, b.onFileSizeLimit, [], !1);
    BsyUtils.isNumber(g) && (f = g);
    if (e && a.size > f) {
      tipAlert({
        msg: React.language("upload.maxLimitTip"),
        type: "warning",
      });
      e = !1;
    }

    return e;
  };

  onChange = (e) => {
    var _this = this;
    var _options = this.options;

    if (1 === _options.maxFileCount) {
      _this.g_files = [];
    }
    this.upFiles = this.$uploadInput.current.files;
    if (_this._checkUploadFiles(_this.upFiles)) {
      // _this._checkDownStatus();
      if (_this.imageType === "base64") {
        window.FX.Utils.data2Base64(_this.upFiles, function (dd) {
          _this.files = dd;
          // _this._createFilePreview(b.files[0]).appendTo(b.$previewList)
          // _this.onSuccess();
        });
        return;
      } else {
        _this.doUpload();
      }
    } else {
      _this.upFiles = null;
    }
  };

  //bsy-subform-upload

  deleteFile = (file) => {
    var a = this.options;
    var dd = this.g_files.filter((item) => {
      return item._id !== file._id;
    });
    this.g_files = [...dd];
    this.setState({}, () => {
      BsyUtils.applyFunc(
        this,
        a.onAfterUpload,
        [
          {
            files: this.files,
            up: 0,
            total: 0,
          },
        ],
        !1
      );
      BsyUtils.applyFunc(this, a.onStopEdit, [this.g_files, null, this], !1);
    });
  };

  onSuccess = () => {
    var a = this.options;
    this.previewlist = [];
    //过滤异常数据
    var tmpvalue = [];
    for (var i = 0; i < this.g_files.length; i++) {
      if (!this.g_files[i].error) {
        tmpvalue.push(this.g_files[i]);
      }
    }
    this.g_files = [...tmpvalue];
    this.setState({}, () => {
      BsyUtils.applyFunc(
        this,
        a.onAfterUpload,
        [
          {
            files: this.files,
            up: 0,
            total: 0,
          },
        ],
        !1
      );
      BsyUtils.applyFunc(this, a.onStopEdit, [this.g_files, null, this], !1);
    });
  };
  onFail = (a) => {
    var b = this.options;
    // b.hasProgress && this.progress.setVisible(!1),
    // this.$uploadBtn.show(),

    //过滤异常数据
    var tmpvalue = [];
    this.previewlist = [];
    for (var i = 0; i < this.g_files.length; i++) {
      if (!this.g_files[i].error) {
        tmpvalue.push(this.g_files[i]);
      }
    }
    this.g_files = [...tmpvalue];
    this.setState({}, () => {
      BsyUtils.applyFunc(this, b.onUploadFail, [], !1);
      BsyUtils.applyFunc(this, b.onStopEdit, [this.g_files, null, this], !1);
    });
  };

  previewFile = (data, index) => {
    // console.log(data)
    const { g_files } = this;
    const _this = this;
    const auth =
      this.props && this.props.onGetAuth
        ? this.props.onGetAuth() || { enable: this.props.enable }
        : { enable: this.props.enable };
    new window.FX.FilePreview({
      fieldName:
        this.props.widgetName || this.props.name || this.options.widgetName,
      files: g_files,
      title: g_files.length === 1 ? g_files[index].name : "",
      widgetType: "upload",
      currentItem: index,
      dataId: this.props.dataId,
      formId: this.props.formId,
      appId: this.props.appId,
      authGroupId: this.props.authGroupId,
      // online_edit: auth.enable && (this.props.formMode === "new" ? false : this.props.online_edit),
      online_edit: this.props.online_edit,
      online_edit_record: this.props.online_edit_record,
      is_file_down: this.props.is_file_down,
      check_image_exif: this.options.check_image_exif,
      hasGraffiti: this.options.enable,
      saveValue: (i) => {
        _this.setValue(i, !0);
      },
      onGraffiti: function (item, index) {
        console.log('onGraffiti', item);
        const $this = this;
        doGraffiti({
          file: item,
          onSave: function (data, type, onClose) {

            const file = BsyUtils.dataURLtoFile(data, item.name)
            _this._checkUploadToken(() => {
              _this._doXhrUpload(file, (progress) => {
                console.log(progress / file.size)
              }, (sucess) => {
                if (type === "cover") {
                  // // --- 同步预览界面的图片 ---
                  // $this.$currentView.find("img").attr("src", sucess.file.compressUrl)
                  // $this.options.files[index] = sucess.file;
                  // // --- 同步预览界面的图片 ---

                  _this.g_files[index] = sucess.file;
                } else {
                  // $this.options.files.push(sucess.file);
                  _this.g_files.push(sucess.file);
                }
                $this.onClose();

                _this.setState({}, () => {
                  BsyUtils.applyFunc(
                    _this,
                    _this.options.onAfterUpload,
                    [
                      {
                        files: _this.files,
                        up: 0,
                        total: 0,
                      },
                    ],
                    !1
                  );
                  BsyUtils.applyFunc(_this, _this.options.onStopEdit, [_this.g_files, null, _this], !1);
                });
                onClose?.()
              })
            })
          }
        })
      },
      autoClose: !1,
    });
  };

  drawImage = (img) => {
    var imgWidth = img.naturalWidth;
    var imgHeight = img.naturalHeight;
    img.style.width = "";
    img.style.height = "";
    img.style.display = "flex";
    if (imgWidth > imgHeight) {
      if (imgWidth > 78) {
        img.style.width = "100%";
      } else {
        img.style.height = "auto";
      }
    } else {
      if (imgHeight > 78) {
        img.style.height = "100%";
      } else {
        img.style.height = "auto";
      }
    }
  };

  renderFileItem = (file, index) => {
    if (!file || !file.qnKey) {
      return (
        <div className="upload-info">
          <div className="loading">
            <div className="node"></div>
            <div className="node"></div>
            <div className="node"></div>
            <div className="node"></div>
            <div className="node"></div>
            <div className="node"></div>
            <div className="node"></div>
            <div className="node"></div>
          </div>
        </div>
      );
    } else {
      var s = BsyUtils.byteFormat2(file.size);
      var n = this._trimFileName(file.name);
      var o = file.name
        ? file.name.split(".").pop()
        : this.options.type == "image"
          ? "png"
          : "";
      var l = BsyUtils.date2Str(new Date(file.uploadTime), "yyyy/MM/dd");

      let i = "normal";
      var b =
        [
          "ppt",
          "pptx",
          "doc",
          "docx",
          "xls",
          "xlsx",
          "zip",
          "rar",
          "csv",
          "txt",
          "pdf",
          "mp4",
          "webm",
          "ogg",
          "mov",
        ].indexOf(o) > -1
          ? o
          : "other";
      //   a('<div class="fui_file_thumb ' + b + " size-" + i + '"/>')

      return (
        <div className="upload-info">
          <div
            className="upload-preview"
            onClick={() => {
              this.previewFile(file, index);
            }}
          >
            {BsyUtils.isImageExt(o) ? (
              <img
                src={BsyUtils.getfiledownloadURL(file, {
                  mode: 2,
                  width: this.options.thumbWidth,
                  height: this.options.thumbHeight,
                })}
                alt=""
                onLoad={(e) => {
                  // this.drawImage(e.currentTarget || e.target)
                }}
              />
            ) : (
              <i className={`bsy_file_thumb icon-bsy-${b} ${b}`}></i>
            )}
          </div>
          <div
            className="upload-file-info"
            onClick={() => {
              this.previewFile(file, index);
            }}
          >
            <div className="info-text" title={file.name}>
              {n}
            </div>
            <div className="info-sub">{s}</div>
          </div>
          <div
            className="upload-info-btn remove-btn"
            onClick={(e) => {
              this.deleteFile(file);
            }}
          >
            <i className="icon-bby-quchu"></i>
          </div>
        </div>
      );
    }
  };

  renderBody = () => {
    const { cssName, uploadURL, fileType, maxFileCount, download } =
      this.options;
    var d = "";
    if (fileType.length) {
      d = "." + fileType.join(",.");
    }

    if (!this.g_files) {
      this.g_files = [];
    }
    if (!this.previewlist) {
      this.previewlist = [];
    }
    if (this.props.mode === "print") {
      return (
        <div className={"upload-preview-list"}>
          {this.g_files.map((file, index) => {
            var s = BsyUtils.byteFormat2(file.size);
            var n = this._trimFileName(file.name);
            var l = BsyUtils.date2Str(new Date(file.uploadTime), "yyyy-MM-dd HH:mm:ss");
            return <div>{[n, s, l].join(" ")}</div>;
          })}
        </div>
      );
    }

    if (cssName.indexOf("bsy-upload") === -1) {
      return (
        <>
          <div
            className={
              "upload-preview-list" +
              (this.g_files.length === 0 && this.previewlist.length === 0
                ? " empty"
                : "")
            }
            style={{
              paddingTop:
                download && this.g_files && this.g_files.length ? "20px" : "",
            }}
          >
            {this.g_files.map((file, index) => {
              return this.renderFileItem(file, index);
            })}
            {this.previewlist.map((file, index) => {
              return this.renderFileItem(file, index);
            })}
          </div>

          {this.isEnabled() ? (
            <div className="upload-btn  ">
              <div className="upload">
                <i className="icon-widget-upload upload-icon"></i>
                <span>{React.language("select.file")}</span>
                <form
                  className="upload-form"
                  action={uploadURL}
                  key={"formk" + this.inputKey}
                  encType="multipart/form-data"
                  method="post"
                >
                  <input
                    type="file"
                    name="file"
                    className="upload-btn-input"
                    accept={d}
                    ref={this.$uploadInput}
                    onChange={this.onChange}
                    multiple={maxFileCount > 1 ? true : false}
                  />
                </form>
              </div>
            </div>
          ) : (
            ""
          )}
        </>
      );
    } else {
      return (
        <>
          <div
            className={
              "upload-preview-list" +
              (this.g_files.length === 0 && this.previewlist.length === 0
                ? " empty"
                : "")
            }
            style={{
              paddingTop:
                download && this.g_files && this.g_files.length ? "20px" : "",
            }}
          >
            {this.g_files.map((file, index) => {
              return this.renderFileItem(file, index);
            })}
            {this.previewlist.map((file, index) => {
              return this.renderFileItem(file, index);
            })}
          </div>
          {this.isEnabled() ? (
            <div className="upload-btn  ">
              <div className="upload">
                <i className="icon-widget-upload upload-icon"></i>
                <span>{React.language("select.file")}</span>
                <form
                  className="upload-form"
                  action={uploadURL}
                  key={"formk" + this.inputKey}
                  encType="multipart/form-data"
                  method="post"
                >
                  <input
                    type="file"
                    name="file"
                    className="upload-btn-input"
                    accept={d}
                    ref={this.$uploadInput}
                    onChange={this.onChange}
                    multiple={maxFileCount > 1 ? true : false}
                  />
                </form>
              </div>
            </div>
          ) : (
            ""
          )}
        </>
      );
    }
  };

  render() {
    const { cssName, css, download } = this.options;
    if (!this.isEnabled() && BsyUtils.isObjectEmpty(this.g_files)) {
      return this.renderDisablePane("");
    }
    return (
      <div className={cssName} style={css} ref={this.element}>
        {this.renderBody()}
        {download && !BsyUtils.isObjectEmpty(this.g_files) ? (
          <div
            className={"download"}
            onClick={(e) => {
              BsyUtils._package("", this.getValue(), this.options);
            }}
          >
            <i className={"icon-download"}></i>
            {React.language("Form.download")}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default BsyFileUpload;
